/* global $:true */

import _ from 'lodash'
import Vue from 'vue'
import { mapActions } from 'vuex'
import ProfileService from '@/services/profile'
import UserService from '@/services/user'
import MembershipService from '@/services/membership'
import SubscriptionService from '@/services/subscription'
import smsService from "@/services/sms";
import { MyEvents, ViolationsEmail, PublicRelationsUsername } from '@/helper'
import albumSlideCard from '@/components/albumslidecard'
import carousel3d from '@/components/slider/Carousel3d'
import merchModal from '@/components/merchmodal'
import shareModal from '@/components/sharemodal'
import productCard from '@/components/productcard'
import productSlideCard from '@/components/productslidecard'
import sendLoveModal from '@/components/sendlovemodal'
import sendMessage from '@/components/sendmessage'
import slide from '@/components/slider/Slide'
import trackCard from '@/components/trackcard'
import userItem from '@/components/useritem'
import artistItem from '@/components/artistitem'
import contentTopHeader from '@/components/contentTopHeader'
import AuthService from '@/services/auth'
import StreamService from '@/services/stream'
import VideoBox from '@/components/video_box'
import UserFollowBtn from "@/components/userFollowBtn"
import VueSlickCarousel from 'vue-slick-carousel'
import moment from 'moment'
import { mapState } from 'vuex'
import { Stripe } from '@/helper'
import { Card, createToken, CardNumber, CardExpiry, CardCvc } from 'vue-stripe-elements'
import membership from '../../services/membership'

// import streamPlayer from '@/components/stream_player'

export default {
  components: {
    trackCard,
    albumSlideCard,
    productCard,
    productSlideCard,
    merchModal,
    shareModal,
    userItem,
    artistItem,
    sendMessage,
    sendLoveModal,
    carousel3d,
    slide,
    contentTopHeader,
    VideoBox,
    UserFollowBtn,
    VueSlickCarousel,
    Card,
    CardNumber,
    CardExpiry,
    CardCvc,
    // streamPlayer
  },

  data() {
    return {
      // active_tab: 'songs',
      // slide_tab: 'songs',
      stripe_publishable_key: process.env.STRIPE_PUBLISHABLE_KEY,
      stripeOptions: {},
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      PublicRelationsUsername: PublicRelationsUsername,
      active_tab: '',
      slide_tab: '',
      show_following: false,     
      show_following_scroll: false,
      show_followers: false,     
      show_followers_scroll: false,
      tabs: [
        { id: 'catalog', title: 'Catalog', roles: ['label'], icon: require('../../../static/images/grid-interface.svg') },
        { id: 'artists', title: 'Artists', roles: ['label'] },
        { id: 'songs', title: 'Music', icon: require('../../../static/images/music.svg') },
        // { id: 'video', title: 'Video', icon: require('../../../static/images/video.svg') },
        // { id: 'merch', title: 'Shop', icon: require('../../../static/images/shop.svg') },
        // { id: 'sms_group', title: 'SMS groups' },
        { id: 'reposted', title: 'Reposted', roles: ['label'], icon: require('../../../static/images/ic_repost.svg') },
        { id: 'downloaded', title: 'Downloaded', roles: ['label'], icon: require('../../../static/images/download.svg') },
        { id: 'followings', title: 'Following' },
        { id: 'followers', title: 'Followers' },
      ],
      slug: null,
      user: {
        display_name: '',
        avatar: {},
      },
      show_block_user_confirm_dialog: false,
      show_invite_confirm_dialog: false,
      showPageMerchModal: false,
      selectedProduct: {},
      showPageShareModal: false,
      showSendMessage: false,
      showShareModal: false,
      showMembershipModal: false,
      showPaymentModal: false,
      showFollowCard: false,
      showSendLoveModal: false,
      show_stream_live_button: false,
      view_stream_clicked: false,
      grid_show: true,
      auto_play: false,
      startIndex: 0,
      page_index: 1,
      total_pages: 0,
      items_per_page: 5 * 10,
      selectedTier: null,
      genres: null,
      genre_index: 0,
      followings_selector: 'followings',
      products: [],
      albums: [],
      users: [],
      buttonHover: false,
      isPageReady: false,
      ownVideos: [],
      smsList: [],
      slickOptions: {
        infinite:false,
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: false,
        cssEase: 'linear',
        arrows: false,
        rows: 1
      },
      allTiers: null,
      monthlyTier: true,
      purchasePrice: null,
      showConfirmPurchaseDialog: false,
      purchaseModal: false,
      stripePriceId: null,
      amount: 0,
      membership_tiers: [],
      membership_id: null,
      darkMode: false,
      show_order_complete_dialog: false,
      stripe_inprogress: false,
    }
  },
  
  computed: {
    ...mapState({
      sideBarWidth: state => state.app.sideBarWidth,
      plansData: (state) => state.app.plansData,
    }),

    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    currentUser() {
      return this.$store.state.auth.user
    },

    userLocation() {
      return _.get(this.user, 'default_address.city', '--')
    },

    enabledViewDirectMessage() {
      return (
        this.currentUser.user_type === 'admin' ||
        (this.currentUser.user_type === 'moderator' &&
          _.get(this.currentUser, 'enabled_view_direct_message') === true)
      )
    },

    coverImageURL() {
      const imageUrl = _.get(
        this.albums,
        `[${this.startIndex}].cover.thumb.url`,
        ''
      )
      if (imageUrl) {
        return imageUrl + '?' + new Date()
      }
      return imageUrl
    },

    albumDisplayCount() {
      if (this.albums.length > 7) {
        return 7
      } else {
        return this.albums.length
      }
    },

    merchDisplayCount() {
      if (this.products.length > 7) {
        return 7
      } else {
        return this.products.length
      }
    },

    streamViewpurchasePrice() {
      return _.get(this.user, 'stream.view_price', 0)
    },

    followMetaVisible() {
      return (
        _.get(this.user, 'username') !== PublicRelationsUsername ||
        _.get(this.currentUser, 'user_type') === 'admin'
      )
    },

    followButtonText() {
      if (this.user.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following'
      }
      return 'Follow'
    },
    smsCount() {
      return this.smsList.length
    },
    isUserSignedUp() {
      return this.currentUser.phone_number;
    },
    userIsFollowing() {
      return this.user.is_following
    },
  },

  watch: {
    $route(toPath, fromPath) {
      const paths = toPath.path.split('/')
      this.slug = paths[1]
      const tab = toPath.hash.substr(1)
      const grid_view =
        toPath.query.grid_view === undefined
          ? true
          : toPath.query.grid_view === 'true' || toPath.query.grid_view === true
      const auto_play =
        toPath.query.auto_play === undefined
          ? false
          : toPath.query.auto_play === 'true' || toPath.query.auto_play === true
      this.init(tab, grid_view, auto_play, false)
    },

    monthlyTier(oldVal, _newVal) {
      this.membership_tiers = oldVal ? this.allTiers.monthly : this.allTiers.annual
    },

    showMembershipModal(oldVal, _newVal) {
      this.selectedTier = oldVal ? this.selectedTier : null
    }
  },

  async created() {
    window.addEventListener('scroll', this.handleScroll)
    this.slug = this.$route.params.slug
    await this.ownStream()

    const tab = this.$route.hash.substr(1)
    const grid_view =
      this.$route.query.grid_view === undefined
        ? true
        : this.$route.query.grid_view === 'true' ||
          this.$route.query.grid_view === true
    const auto_play =
      this.$route.query.auto_play === undefined
        ? false
        : this.$route.query.auto_play === 'true' ||
          this.$route.query.auto_play === true
    this.init(tab, grid_view, auto_play, true)

    this.$root.$on(MyEvents.USER_FOLLOW, this.setFollowingStatus)

    this.listAllSMS()
  },

  beforeDestroy() {
    this.$root.$off(MyEvents.USER_FOLLOW, this.setFollowingStatus)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions({
      setPlaylist: 'player/setPlaylist',
      setPlaylistIndex: 'player/setListIndex',
      setPlaying: 'player/setPlayingStatus',
    }),

    async ownStream(tab, page) {
      this.$store.dispatch('error/showLoadingActivity', true)
      let userId = this.currentUser.id
      await UserService.getUserInfo(this.slug)
        .then((response) => { userId = response.body.id })
        .catch((err) => { console.log('error in fetching user info', err) })
      const params = {
        genre_id: 0, // default for all videos
        only_follows: this.only_follows,
        page: 1, // get page 1
        per_page: 100,
        user_id: userId
      }
      console.log("========================", userId)
      StreamService.getStreams(params)
        .then((response) => {
          console.log(response.body.streams)
          this.ownVideos = response.body.streams.filter((str) => this.user.display_name == str.user.display_name)
          // this.ownVideos = this.ownVideos.concat(response.body.streams)
          // this.ownVideos = [ ...this.ownVideos, ...this.ownVideos]
          this.pagination = response.body.pagination
          this.videoGenres = response.body.genres
          this.$store.dispatch('error/showLoadingActivity', false)
        })
        .catch(() => {
          this.$store.dispatch('error/showLoadingActivity', false)
        })
    },

    loadMore() {
      this.loadData(this.pagination.current_page + 1)
    },
    handleScroll(event) {
      if(this.show_following){
        const navProfileCard = document.querySelector('.special-scroll-header')

        var y = window.scrollY
        if (y >= 75) {
          this.show_following_scroll = true
          this.show_followers_scroll = true
        } else {
          this.show_following_scroll = false
          this.show_followers_scroll = false
        }
      }
      else{
        this.show_following_scroll = false
        this.show_followers_scroll = false
      }
    },
    isActiveTab(tab) {
      return this.active_tab === tab
    },

    onTab(tab) {
      if(tab == "followings"){
        console.log('user',this.currentUser)
        if(this.currentUser.id != this.user.id){
          this.show_following = true;
        }         
      }
      else if(tab == "followers"){
        console.log('user',this.currentUser)
        if(this.currentUser.id != this.user.id){
          this.show_followers = true;
        }         
      }
      else{
        this.show_following = false;
        this.show_following_scroll = false
        this.show_followers = false;
        this.show_followers_scroll = false
      }
      this.$router.push({
        path: this.$route.path,
        hash: tab,
        // query: {
        //   grid_view: this.grid_show
        // }

      })
    },

    setGridView(flag) {
      this.$router.push({
        path: this.$route.path,
        hash: this.active_tab,
        // query: {
        //   grid_view: flag
        // }
      })
    },

    isStreaming() {
      // console.log(_.get(this.$store.state.streamPlayer.user, 'slug', ''), this.user.slug, this.$store.state.streamPlayer.frame_mode)
      return (
        _.get(this.user.stream, 'status', '') === 'running' &&
        _.get(this.user.stream, 'notified', false) &&
        (_.get(this.$store.state.streamPlayer.stream, 'user.slug', '') !==
          this.user.slug ||
          !this.$store.getters['streamPlayer/hasFrame'])
      )
    },

    viewStream() {
      console.log('viewStream clicked')
      this.view_stream_clicked = true
      UserService.getUserInfo(this.slug)
        .then((response) => {
          this.user = response.body
          this.view_stream_clicked = false

          if (this.isStreaming()) {
            this.$store.dispatch('streamPlayer/setStream', this.user.stream)
            this.$root.$emit(MyEvents.STREM_PLAYER_INIT)
          }
        })
        .catch((err) => {
          console.log('profle/viewStream', err)
          this.view_stream_clicked = false
        })
    },

    init(tab, grid_view, auto_play, first_visit) {
      this.show_stream_live_button = false
      this.showSendMessage = false
      this.startIndex = 0
      this.genres = [
        {
          id: 'any',
          name: 'Any genre',
          slug: 'any',
        },
      ]
      this.total_pages = 0

      this.$store.dispatch('error/showLoadingActivity', true)
      UserService.getUserInfo(this.slug)
        .then((response) => {
          if (response.body.status !== 'active') {
            this.$store.dispatch('error/showErrorToast', [
              'User does not exist',
            ])
            this.$router.push({ name: 'AlbumIndex' })
            return
          }

          // console.log('profile init')
          this.user = response.body
          this.$emit('updateHead')

          if (this.isStreaming()) {
            Vue.http.get(this.user.stream.mp_channel_1_ep_1_url).then(() => {
              this.show_stream_live_button = true
              if (first_visit) {
                // console.log('calling ...', MyEvents.STREM_PLAYER_INIT)
                this.$store.dispatch('streamPlayer/setStream', this.user.stream)
                this.$root.$emit(MyEvents.STREM_PLAYER_INIT)
              }
            })
            // this.$store.dispatch('streamPlayer/setStream', this.user.stream)
            // this.$root.$emit(MyEvents.STREM_PLAYER_INIT)
          }

          // // put 'merch' tab first for brand
          // if (this.user.user_type === 'brand') {
          //   if (this.tabs[7].id === 'merch') {
          //     this.tabs.unshift(this.tabs.pop())
          //   }
          // } else {
          //   if (this.tabs[7].id !== 'merch') {
          //     this.tabs.push(this.tabs.shift())
          //   }
          // }
          if (this.currentUser.id === this.user.id) {
            this.tabs.filter(tab => tab.id == 'songs')[0].title = 'Releases'
          } else {
            this.tabs = this.tabs.filter(tab => tab.id !== 'sms_group')
          }
          if (tab) {
            this.active_tab = tab
            this.slide_tab = tab
          } else {
            switch (this.user.user_type) {
              case 'artist':
                this.active_tab = 'songs'
                this.slide_tab = 'songs'

                // this.active_tab = 'followings'
                // this.slide_tab = 'followings'
                break
              case 'label':
                this.active_tab = 'artists'
                this.slide_tab = 'artists'
                break
              case 'brand':
                this.active_tab = 'merch'
                this.slide_tab = 'merch'
                break
              default:
                // this.active_tab = 'playlists'
                // this.slide_tab = 'playlists'
                this.active_tab = 'reposted'
                this.slide_tab = 'reposted'
                break
            }
          }

          this.grid_show = grid_view
          this.auto_play = auto_play
          this.$store.dispatch('player/setGridShow', grid_view)
          if (grid_view) {
            this.active_tab = this.slide_tab
            this.$store.dispatch('navigator/goNextState', {
              page: 'profile',
              tab: this.active_tab,
            })
          } else {
            this.slide_tab = this.active_tab
            this.$store.dispatch('navigator/goNextState', {
              page: 'profile-slider',
              tab: this.active_tab,
            })
          }

          if (this.active_tab !== 'video' && this.active_tab !== 'sms_group') {
            // temp implementation because there is no video 'getItems' yet
            this.getItems(this.active_tab, false)
          }
          this.isPageReady = false
          this.$store.dispatch('error/showLoadingActivity', false)

          if (window.location.search == '?membership_tier_modal' && this.user.membership_tiers != 0 &&
              this.currentUser.id != this.user.id) {
            this.showMembershipDialog()
          }
        })
        .catch((e) => {
          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch('error/showErrorToast', ['User does not exist'])
          this.$router.push({ path: '/' })
          // this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
          // setTimeout(() => {
          //   this.$router.push({ path: '/album' })
          // }, 5000)
        })
    },

    getItems(tab, loadMore) {
      if (!loadMore) {
        this.albums = []
        this.products = []
        this.users = []
        this.startIndex = 0
        this.page_index = 1
      } else {
        this.page_index += 1
      }

      var params = {
        page: this.page_index,
        per_page: this.items_per_page,
      }
      this.$store.dispatch('error/showLoadingActivity', true)
      ProfileService.getItems(this.user.id, tab, params)
        .then((response) => {
          console.log(response.body);
          this.$store.dispatch('error/showLoadingActivity', false)
          switch (tab) {
            case 'merch':
              this.products = this.products.concat(response.body.products)
              break
            case 'followers':
            case 'followings':
            case 'artists':
              this.users = this.users.concat(response.body.users)
              break
            case 'video':
              this.users = this.users.concat(response.body.users)
              break
            case 'sms_group':
              break
            default:
              let albums = []
              if (tab === 'reposted' || tab === 'downloaded') {
                for (let index in response.body.feeds) {
                  if (response.body.feeds[index].assoc_type === 'Album') {
                    albums.push(response.body.feeds[index].assoc)
                  }
                }
              } else {
                albums = response.body.albums
              }
              this.fillAlbums(albums)

              if (tab === 'songs' && this.auto_play) {
                this.auto_play = false
                this.playSong()
              }

              if (!this.grid_show) {
                this.changeBackground()
              }
              break
          }

          this.page_index = response.body.pagination.current_page
          this.total_pages = response.body.pagination.total_pages
        })
        .catch((e) => {
          console.log(e)
          console.log(e.message)
          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch(
            'error/showErrorToast',
            e.body.errors || [e.body]
          )
        })
    },

    fillAlbums(albums) {
      let genres = this.genres.slice()
      for (let album_index in albums) {
        const album = albums[album_index]
        genres = genres.concat(album.genres)
        album.genre_ids = _.map(album.genres, 'id').join(',')
        this.albums.push(album)

        /* focus the album on playing in slider view */
        if (this.$store.state.player.isPlaying && !this.grid_show) {
          const currentItem = this.$store.state.player.list[
            this.$store.state.player.listIndex
          ]
          if (currentItem.assoc_type) {
            if (currentItem.assoc.id === album.id) {
              this.startIndex = album_index
            }
          } else {
            if (currentItem.id === album.id) {
              this.startIndex = album_index
            }
          }
        }
      }
      this.genres = _.uniqBy(genres, 'id')
      // console.log(this.active_tab, albums)
      // console.log(this.albums)
    },

    setFollowingsSelector(value, name) {
      if (this.followings_selector !== value) {
        this.followings_selector = value
        $('#followings_selector .btn__content').html(
          name +
            '<i class="material-icons icon icon--right theme--dark">keyboard_arrow_down</i>'
        )
        this.getItems(this.active_tab, false)
      }
    },

    onAfterAlbumSlideChange(index) {
      // if(this.$store.state.player.isPlaying && this.$store.state.player.page === 'profile' && !this.grid_show) {
      //   this.$refs.albumCarousel.goSlide(this.$store.state.player.listIndex)
      // } else {
      //   this.startIndex = index
      // }
      this.startIndex = index
      this.changeBackground()
    },

    onAfterMerchSlideChange(index) {},

    changeBackground() {
      var canvas = document.getElementById('canvas')
      var cctx = canvas.getContext('2d')
      if (this.coverImageURL) {
        var buff = document.createElement('canvas')
        buff.width = canvas.width
        buff.height = canvas.height
        var imageObj = new Image()
        // this will make CORS happy because the server is well configured
        imageObj.crossOrigin = 'anonymous'
        // Easiest is to always host your images on your own server
        // imageObj.src = 'https://dl.dropboxusercontent.com/s/8q8sjnqmmto13h5/lionCMYK.jpg'
        imageObj.src = this.coverImageURL
        imageObj.onload = function () {
          // canvas.width = imageObj.height
          // canvas.height = imageObj.height
          cctx.drawImage(imageObj, 0, 0)
          window.StackBlur.image(imageObj, canvas, 70, false)
        }
      } else {
        cctx.clearRect(0, 0, canvas.width, canvas.height)
      }
    },

    isAvailableForSlideView(tab) {
      return (
        ['artists', 'followings'].indexOf(tab.id) === -1 &&
        (!tab.roles || tab.roles.indexOf(this.user.user_type) > -1)
      )
    },

    isAvailableForGridView(tab) {
      return !tab.roles || tab.roles.indexOf(this.user.user_type) > -1
    },

    closePageMerchModal() {
      this.showPageMerchModal = false
    },

    openPageMerchModal(product) {
      // console.log('openPageMerchModal', product)
      this.selectedProduct = product
      this.$nextTick(() => {
        this.showPageMerchModal = true
      })
    },

    closePageShareModal() {
      this.showPageShareModal = false
    },

    openPageShareModal() {
      // console.log('openPageShareModal')
      this.showPageMerchModal = false
      this.showPageShareModal = true
    },

    showMessageDialog() {
      this.showSendMessage = true
    },

    dismissMessageModal() {
      this.showSendMessage = false
    },

    showLoveDialog() {
      this.showSendLoveModal = true
    },

    dismissLoveDialog() {
      this.showSendLoveModal = false
    },

    viewDirectMessages() {
      this.$router.push({ path: '/user/' + this.user.slug + '/messages' })
    },

    goToChat() {
      this.$router.push({ path: '/user/' + this.user.slug + '/chat' })
    },

    flagUser() {
      const emailTo = ViolationsEmail
      const emailCC = ''
      const emailSub = ''
      const emailBody = ''
      window.open(
        `mailto:${emailTo}?cc=${emailCC}&subject=${emailSub}&body=${emailBody}`,
        '_blank'
      )
    },

    openBlockUserConfirmDialog() {
      this.show_block_user_confirm_dialog = true
    },

    closeBlockUserConfirmDialog() {
      this.show_block_user_confirm_dialog = false
    },

    blockUser() {
      UserService.blockUser(this.user.id)
        .then((response) => {
          this.$store.dispatch('error/showSuccessToast', [
            'You blocked ' +
              this.user.display_name +
              ', go to settings page to unblock',
          ])
        })
        .catch((e) => {
          this.$store.dispatch(
            'error/showErrorToast',
            e.body.errors || [e.body]
          )
        })
      this.closeBlockUserConfirmDialog()
    },

    setFollowingStatus(userId, isFollowing) {
      if (this.user && this.user.id === userId) {
        this.user.is_following = isFollowing
      }
    },

    openInviteConfirmDialog() {
      this.show_invite_confirm_dialog = true
    },

    closeInviteConfirmDialog() {
      this.show_invite_confirm_dialog = false
    },

    inviteUser() {
      this.closeInviteConfirmDialog()
      UserService.inviteUser(this.user.id).then((response) => {
        this.user = response.body
        this.$store.dispatch('error/showSuccessToast', ['Invited'])
      })
    },

    playSong() {
      if (this.active_tab === 'songs' || this.albums.length) {
        this.setPlaylist(this.albums)
        this.setPlaylistIndex(0)
        this.setPlaying(true)
        this.$root.$emit('play')
      } else {
        this.$router.push({
          path: this.$route.path,
          hash: 'songs',
          query: {
            // grid_view: this.grid_show,
            auto_play: true,
          },
        })
      }
    },

    moveSlide() {
      if (this.$refs.albumCarousel !== undefined) {
        const lastState = this.$store.getters['navigator/last']
        if (lastState.page === 'profile') {
          this.$refs.albumCarousel.goSlide(this.$store.state.player.listIndex)
        } else {
          var playingIndex = -1
          for (let index in this.albums) {
            var currentItem = this.albums[index]
            var playingItem = this.$store.state.player.list[
              this.$store.state.player.listIndex
            ]
            if (playingItem !== undefined) {
              if (playingItem.assoc_type === 'Album') {
                playingItem = playingItem.assoc
              }
              if (playingItem.id === currentItem.id) {
                playingIndex = index
                break
              }
            }
          }
          this.$refs.albumCarousel.goSlide(parseInt(playingIndex))
        }
      }
    },
    signOut() {
      AuthService.signout()
      this.$router.push({ path: '/login' })
      this.$root.$emit(MyEvents.AUTH_SIGNOUT)
    },
    listAllSMS() {
      smsService
        .listSMS()
        .then((response) => {
          this.smsList = response.body;
        })
        .catch((e) => {
          this.$store.dispatch(
            "error/showErrorToast",
            e.body.errors || [e.body]
          );
        });
    },
    setMenuAction(menu) {
      switch (menu.id) {
        case "profile":
          this.$router.push(`/${this.currentUser.slug}`);
          break;
        case "signOut":
          this.signOut();
          break;
        default:
          this.$router.push({ name: menu.pathName });
          break;
      }
    },

    showMembershipDialog() {
      this.getMembershipTiers();
    },

    showPaymentDialog(){
      this.showPaymentModal = true;
    },

    showFollowCardDialog(){
      this.showFollowCard = true;
    },

    dismissMembershipDialog(){
      this.showMembershipModal = false;
    },

    dismissPaymentDialog(){
      this.showPaymentModal = false;
    },

    getMembershipTiers() {
      UserService.getMembershipTiers(this.user.id)
        .then((response) => {
          this.allTiers = { monthly: [], annual: []}
          for (const tier of response.body.monthly) {
            if (tier.content_present)
              this.allTiers['monthly'].push(tier)
          }

          for (const tier of response.body.annual) {
            console.log(tier)
            if (tier.content_present)
              this.allTiers['annual'].push(tier)
          }

          this.membership_tiers = this.monthlyTier ? this.allTiers.monthly : this.allTiers.annual
          this.showMembershipModal = true
        })
        .catch((e) => {
          this.$store.dispatch(
            'error/showErrorToast',
            e.body.errors || [e.body]
          )
        })
    },

    purchaseMembership(tier, membership_id = null) {
      if (this.purchaseMembershipBtnTitle(tier) == 'Visit membership area')
        return this.$router.push({ path: `/members/${this.user.slug}` })

      this.selectedTier = tier
      this.membership_id = membership_id

      if (this.currentUser.stripe_customer_id == null) {
        this.purchasePrice = this.selectedTier.total_price
        this.showPaymentDialog()
      }
      else {
        this.purchasePrice = this.selectedTier.total_price
        this.openPurchaseModal()
      }
    },

    openPurchaseModal() {
      this.purchaseModal = true
    },

    hidePurchaseModal() {
      this.purchaseModal = false
    },

    handlePayment() {
      createToken().then((data) => {
        this.storeCard(data.token)
      });
    },

    storeCard(token_response) {
      UserService.storeCard(this.currentUser.id, { token_response: token_response })
        .then(response => [
          this.purchase()
        ])
        .catch(e => {
          this.$store.dispatch(
            'error/showErrorToast',
            ["Unable to store payment information"]
          )
        })
    },

    purchase() {
      if (this.getMembershipId(this.selectedTier))
        return this.update()

      this.stripe_inprogress = true;
      MembershipService.purchaseMembership({ membership_tier_id: this.selectedTier.id })
        .then((response) => {
          this.paymentSuccessful = true
          this.purchaseModal = false
          this.showMembershipModal = false;
          this.showPaymentModal = false;

          this.updateCurrentUserInfo()
          this.followUser(response)
          this.stripe_inprogress = false;
        })
        .catch((e) => {
          this.stripe_inprogress = false;
          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch(
            'error/showErrorToast',
            ["Purchase unsuccessful"]
          )
        })
    },

    update() {
      this.stripe_inprogress = true;
      MembershipService.updateMembership(this.getMembershipId(this.selectedTier), { membership_tier_id: this.selectedTier.id })
        .then((response) => {
          this.paymentSuccessful = true
          this.purchaseModal = false
          this.showMembershipModal = false
          this.showPaymentModal = false

          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch('error/showSuccessToast', ["You have successfully updated this membership."])

          this.updateCurrentUserInfo()
          this.$forceUpdate()
          this.show_order_complete_dialog = true
          this.stripe_inprogress = false;
        })
        .catch((e) => {
          this.stripe_inprogress = false;
          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch(
            'error/showErrorToast',
            ["Purchase unsuccessful"]
          )
        })
    },

    updateCurrentUserInfo() {
      UserService.getUserInfo(this.currentUser.id).then(
        (response) => {
          AuthService.setUser(response.body)
          this.$store.dispatch('auth/setUser', response.body)
        }
      )
    },

    followUser() {
      if (this.user.is_following) {
        this.$store.dispatch('error/showSuccessToast', [`You have successfully purchased the membership`])
        this.$forceUpdate()
        this.show_order_complete_dialog = true
      } else {
        UserService.followUser(this.user.id, {})
          .then(response => {
            this.user.is_following = true
            this.$store.dispatch('error/showLoadingActivity', false)
            this.$store.dispatch('error/showSuccessToast',
              [`You have successfully purchased this membership. You are now following ${this.user.display_name}`]
            )

            this.$forceUpdate()
            this.show_order_complete_dialog = true
          })
          .catch(e => {
            this.$store.dispatch(
              'error/showErrorToast',
              e.body.errors || [e.body]
            )
          })
      }
    },
    
    purchaseMembershipBtnTitle(tier) {
      for (const membership of this.currentUser.memberships) {
        if (membership.membership_tier_id == tier.id) {
          return 'Visit membership area'
        } else if (tier.membership_tier_id == membership.membership_tier_id) {
            return 'Switch to Annual'
        } else if (membership.membership_tier != undefined && tier.id == membership.membership_tier.membership_tier_id) {
          return 'Switch to Monthly'
        }
      }

      return 'Purchase'
    },

    getMembershipId(tier) {
      for (const membership of this.currentUser.memberships) {
        if (membership.membership_tier_id == tier.id) {
          return membership.id
        } else if (tier.membership_tier_id == membership.membership_tier_id) {
          if (tier.plan_type == 'monthly') {
            return null
          } else {
            return membership.id
          }
        } else if (membership.membership_tier != undefined && tier.id == membership.membership_tier.membership_tier_id) {
          return membership.id
        }
      }

      return null
    },

    purchasedPlan(tier) {
      for (const membership of this.currentUser.memberships) {
        if (membership.membership_tier_id == tier.id) {
          return true
        }
      }

      return false
    },

    totalPayable() {
      return (this.purchasePrice / 100) + (this.currentUser.plan == null ? parseInt(this.amount) : 0)
    },

    fromNow(date) {
      return moment(date).fromNow()
    },
    modeToggle() {
      let app_container = $(this.$parent.$parent.$el);
      if (this.darkMode) {
        app_container.find('.app-container').addClass('dark-mode bg-grey')
      } else {
        app_container.find('.app-container').removeClass('dark-mode bg-grey')
      }
    },
  },

  mounted() {
    this.modeToggle();
    this.$root.$on('index_change', this.moveSlide)
    $(window)
      .resize(function () {
        var height = $('#user_info_page').height() + 230
        var screen_height = $(window).height()
        if (height > screen_height) {
          height += 50
        } else {
          height = screen_height
        }
        var canvas = document.getElementById('canvas')
        if (canvas) {
          $('#canvas').css('cssText', 'height: ' + height + 'px !important;')
        }
        $('#back_image').css('cssText', 'height: ' + height + 'px !important;')
      })
      .trigger('resize')
  },

  head: {
    title() {
      return {
        inner: _.get(this.user, 'display_name', ''),
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/user/profile.ctrl.js